var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSymbolCanteramed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139.89,
    height: 139.28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#00A7D8;}\r\n\t.st1{fill:#0080B5;}\r\n\t.st2{fill:#005081;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 141.89,
    height: 141.28,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "70.85003662109375,89.84001159667969 53.410064697265625,80.18000793457031 53.410064697265625,99.50001525878906 53.410064697265625,129.80999755859375 88.2900390625,129.80999755859375 88.2900390625,99.50001525878906 ",
    id: "svg_27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.410064697265625,10 53.410064697265625,40.31001281738281 70.85003662109375,49.96998596191406 88.2900390625,59.62998962402344 88.2900390625,40.31001281738281 88.2900390625,10 ",
    id: "svg_28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "114.80001831054688,25.629989624023438 88.2900390625,40.31001281738281 88.2900390625,59.62998962402344 88.2900390625,80.18000793457031 106.85003662109375,69.90000915527344 131.70001220703125,56.13999938964844 ",
    id: "svg_29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "34.85003662109375,69.90000915527344 10,83.66999816894531 26.90008544921875,114.18000793457031 53.410064697265625,99.50001525878906 53.410064697265625,80.18000793457031 53.410064697265625,59.62998962402344 ",
    id: "svg_30"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "106.85003662109375,69.90000915527344 88.2900390625,80.18000793457031 70.85003662109375,89.84001159667969 88.2900390625,99.50001525878906 114.80001831054688,114.18000793457031 131.70001220703125,83.66999816894531 ",
    id: "svg_31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "53.410064697265625,40.31001281738281 26.90008544921875,25.629989624023438 10,56.13999938964844 34.85003662109375,69.90000915527344 53.410064697265625,59.62998962402344 70.85003662109375,49.96998596191406 ",
    id: "svg_32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbolCanteramed);
export default __webpack_public_path__ + "static/media/logo-symbol-canteramed.d5b4657154297349fb355bc3eb2cee1f.svg";
export { ForwardRef as ReactComponent };